

document.addEventListener('DOMContentLoaded', () => {


    document.body.addEventListener('click', (e) => {
        const link = e.target.closest('a');
        if (!link) return;

        const href = link.getAttribute('href');
        const currentHrefLine = new URL(window.location.origin + '/' + href);
        const hash = currentHrefLine.hash;

        if (href && href.startsWith('#')) {
            e.preventDefault();



            const targetId = href.substring(1).split('?')[0];
            scrollToElement(targetId);

            if (hash.includes('?')) {
                const queryStringFromHash = hash.split('?')[1];
                const params = new URLSearchParams(queryStringFromHash);

                const handle = params.get('handle');

                if (document.querySelector(`a[data-handle="${handle}"]`)) {
                    document.querySelector(`a[data-handle="${handle}"]`).click()
                }
            }

        }

        else if (href && href.includes('#')) {
            const url = new URL(link.href);

            if (url.pathname === window.location.pathname || url.pathname === '/' + window.location.pathname.split('/').pop()) {
                e.preventDefault();



                const targetId = url.hash.substring(1).split('?')[0];
                scrollToElement(targetId);


                if (hash.includes('?')) {
                    const queryStringFromHash = hash.split('?')[1];
                    const params = new URLSearchParams(queryStringFromHash);

                    const handle = params.get('handle');

                    if (document.querySelector(`a[data-handle="${handle}"]`)) {
                        document.querySelector(`a[data-handle="${handle}"]`).click()
                    }
                }


            }
        }
    });


    if (window.location.hash) {

        setTimeout(() => {
            const targetId = window.location.hash.substring(1);
            scrollToElement(targetId);
        }, 100);
    }


    function scrollToElement(id) {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });

            history.pushState(null, null, `#${id}`);
        }
    }
});



class VariantTextManager extends HTMLElement {
  constructor() {
    super();
    this.allTexts = this.querySelectorAll('.variant-special-text');
  }

  connectedCallback() {
    
    document.addEventListener('change', (event) => {
      
      if (event.target.classList.contains('product-variant__input')) {
        this.updateVisibility(event.target.dataset['variantId']);
      }
    });

    
    this.initFirstLoad();
  }

  initFirstLoad() {
    
    const checkedInput = document.querySelector('.product-variant__input:checked');
    if (checkedInput) {
      this.updateVisibility(checkedInput.dataset['variantId']);
    }
  }

  updateVisibility(selectedValue) {
    if (!selectedValue) return;

    
    const val = selectedValue.toLowerCase();

    this.allTexts.forEach(textBlock => {
      const blockId = textBlock.dataset.id.toLowerCase();

     
      if (val.includes(blockId)) {
        textBlock.style.display = 'block';
      } else {
        textBlock.style.display = 'none';
      }
    });
  }
}


document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('variant-text-manager')) {
  customElements.define('variant-text-manager', VariantTextManager);
}
});



class StickyBuy extends HTMLElement {
    constructor() {
        super();
        this.productSlag = this.dataset.slug;
        this.currentVariantId = Number(this.dataset.currentid);
        this.stickyBuyClose = this.querySelectorAll('.js-sticky-buy-close');
        this.stickyBuyOpen = this.querySelector('.js-sticky-buy-open');
        this.stickyBuyPrice = this.querySelectorAll('.js-sticky-buy-price');
        this.stickyBuyProduct = this.querySelector('.js-sticky-buy-product');
        this.stickyDddToCart = this.querySelector('.js-sticky-add-to-cart');
        this.customVariants = JSON.parse(this.dataset.customvariants);
        this.realVariants = JSON.parse(this.dataset.realvariants);
    
    } 

    connectedCallback() {

  console.log(this.customVariants, this.realVariants)
   
         const targetElement1 = document.querySelector('.product-actions .product__cart-functions');
        const targetElement2 = document.querySelector('.main-footer');

    
        if (this) {
          let visibilityMap = new Map();

          const observerStickuAddTOCart = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              visibilityMap.set(entry.target, entry.isIntersecting);
            });

            const anyVisible = Array.from(visibilityMap.values()).some(v => v === true);

            if (anyVisible) {
              this.classList.remove('active');
              this.classList.remove('open');
              document.querySelector('body').classList.remove('sticky-open');
            } else {
              document.querySelector('body').classList.add('sticky-open');
              this.classList.add('active');
            }
          });

          const targets = [targetElement1, targetElement2];

          targets.forEach(el => {
      
              if (el) {
                  visibilityMap.set(el, false); 
                  observerStickuAddTOCart.observe(el);
              }
          });
          
        }

         document.addEventListener('click', (e) => {

                  if (!e.target.closest('.sticky-option-wrp')) {
                    
                      document.querySelectorAll('.sticky-option-wrp.open').forEach(item => {
                          item.classList.remove('open');
                      });
                  }
              });
   

      this.openPopup()

      this.closePopup();

    
      

    }


    createStickyProduct(){

     
         //if variant list already generated we return
        if(this.querySelectorAll('.sticky-product-options').length) return

            fetch(this.productSlag+'.js')
            .then(response => response.json())
            .then(data => {
               
                //check product options has

                    let productOptions =  false;
                    if(data.options.length > 0) productOptions = true;


                    this.stickyBuyProduct.innerHTML = `

                        <div class="sticky-product-options">
                            ${ productOptions ? `
                                <div class="sticky-product-options-list">
                                  ${data.options.map(option => `
                                  <div class="sticky-option-col">
                                      <div class="sticky-option-name">${option.name}</div>
                                      <div class="sticky-option-wrp">
                                        <div class="js-option-current sticky-option-current"></div>
                                        <div class="sticky-option-list">${option.values.length > 0 ? `
                                            ${option.values.map((value, index) => `
                                                <div class="sticky-option-input">
                                                <input type="radio" ${ index  === 0 ? 'checked' : ''} 
                                                id="${option.name.replaceAll(' ','_').toLowerCase()}-${data.id}-${index}" 
                                                value="${value.replaceAll('"','')}" name="${option.name.replaceAll(' ','_').toLowerCase()}-${data.id}">
                                                <label for="${option.name.replaceAll(' ','_').toLowerCase()}-${data.id}-${index}">${value}</label>
                                                
                                                </div>
                                            `).join('')}
                                        ` : ``}</div>
                                      </div>
                                  </div>`).join('')}
                                  </div>
                              ` : '' }
       
                        </div>
                      
                    `;


          

                  
                    //if product has options run method variantsChange()
                    if(data.options.length > 0){

                      this.customSelectVariantsDefault();

                      this.variantsChange(data.variants);


                       
                    }
                
                
                
                
                this.addTocartProduct();
                
            })
            .catch(error => {
                console.log(error);
            })

              
    }



    variantsChange(variantsArray){


      
            if(this.customVariants === false){
        
                if (variantsArray.length !== 0){

              
                    let currentVarianObject = null;
                    let checkedVariant = Array.from(this.querySelectorAll('.sticky-product-options input[checked]'))
                    .map(input => input.value.replaceAll('"',''))
                    .join(' / ');


                    currentVarianObject = variantsArray.filter(variant => variant.title.replaceAll('"','') === checkedVariant ? variant.id : null)

                    this.currentVariantId = currentVarianObject[0].id;

                  //add default select value
                   this.querySelectorAll('.sticky-option-input input:checked').forEach(item => {
                      if(item.closest('.sticky-option-wrp').querySelector('.js-option-current')){
                        item.closest('.sticky-option-wrp').querySelector('.js-option-current').textContent = item.value;
                      }
                    })

                    
                    const usdFormatter = new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD',
                      
                    });

                    this.querySelectorAll('.sticky-product-options input').forEach(input => {
                        input.addEventListener('change', (event) => {


                            checkedVariant = Array.from(this.querySelectorAll('.sticky-product-options input:checked'))
                                .map(input => input.value.replaceAll('"',''))
                                .join(' / ');

                                
                                currentVarianObject = variantsArray.filter(variant => variant.title.replaceAll('"','') === checkedVariant ? variant.id : null)
                                
                                //  console.log(checkedVariant, currentVarianObject)
                                
                                this.currentVariantId = currentVarianObject[0] != undefined ? currentVarianObject[0].id : undefined;
                                
                                if(currentVarianObject[0] === undefined || currentVarianObject[0].available === false){
                                  this.stickyDddToCart.setAttribute('disabled', true)
                                }else{
                                  this.stickyDddToCart.removeAttribute('disabled')
                                }

                               
                               if(input.closest('.sticky-option-wrp').querySelector('.js-option-current')){
                                input.closest('.sticky-option-wrp').querySelector('.js-option-current').textContent = input.value;
                                input.closest('.sticky-option-wrp').classList.remove('open')  
                              }

                       
                              if(this.stickyBuyPrice.length > 0){
                                this.stickyBuyPrice.forEach(price => {
                                   const value = currentVarianObject[0].price / 100;
                                   const compareValue = currentVarianObject[0].compare_at_price != null ? currentVarianObject[0].compare_at_price / 100 : null;
        
                                    price.innerHTML = (compareValue != null ? `<span class="sticky-add-to-cart-compare-at-price"><s>${usdFormatter.format(compareValue)}</s></span> ` : '') + `<span class="sticky-add-to-cart-price">${usdFormatter.format(value)}</span>`;

                                })
                              }

                        })
                    })

                   

                }

            }else{
              


                this.querySelectorAll('.sticky-option-input input:checked').forEach(item => {
                  if(item.closest('.sticky-option-wrp').querySelector('.js-option-current')){
                    item.closest('.sticky-option-wrp').querySelector('.js-option-current').textContent = item.nextElementSibling.textContent;
                  }
                })
               
                this.querySelectorAll('.sticky-product-options input').forEach(input => {
                    input.addEventListener('change', (event) => {

                            this.currentVariantId = event.currentTarget.value;
                    
                            if(this.stickyBuyPrice.length > 0){
                                this.stickyBuyPrice.forEach(price => {
                                
                                    price.textContent = event.currentTarget.dataset.price;
                                })
                              }


                                if(input.closest('.sticky-option-wrp').querySelector('.js-option-current')){
                                input.closest('.sticky-option-wrp').querySelector('.js-option-current').textContent = input.nextElementSibling.textContent;
                                input.closest('.sticky-option-wrp').classList.remove('open')  
                              }

                    })
                })
            }
           
            
          
        }



        customSelectVariantsDefault(){

      
            const triggers = this.querySelectorAll('.js-option-current');

                if (triggers.length > 0) {
                    triggers.forEach(trigger => {
                      
                        const newTrigger = trigger.cloneNode(true);
                        trigger.parentNode.replaceChild(newTrigger, trigger);

                        newTrigger.addEventListener('click', (e) => {
                          
                            e.stopPropagation(); 

                            const wrapper = newTrigger.closest('.sticky-option-wrp');
                            const isOpened = wrapper.classList.contains('open');

                          
                            this.querySelectorAll('.sticky-option-wrp.open').forEach(openedItem => {
                                if (openedItem !== wrapper) {
                                    openedItem.classList.remove('open');
                                }
                            });

                          
                            if (isOpened) {
                                wrapper.classList.remove('open');
                            } else {
                                wrapper.classList.add('open');
                            }
                        });
                    });
                }

        }

        addTocartProduct(){
            
         

            this.stickyDddToCart.addEventListener('click', (e) => {

              // console.log(this.currentVariantId)

              e.preventDefault();

             

              if(e.currentTarget.getAttribute('disabled') === 'true') return;

               e.currentTarget.querySelector('.button__text').style.opacity = '0';
                  e.currentTarget.querySelector('.button__loader').style.opacity = '1';
            
              let formData = {
                'items': [{
                  'id': this.currentVariantId,
                  'quantity': 1
                  }]
                };

                fetch(window.Shopify.routes.root + 'cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(formData)
                })
                .then(response => {
                  return response.json();
                })
                .then(data => {
                  console.log('show drawer cart')
                    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
                    document.dispatchEvent(new CustomEvent('theme:product:added', { bubbles: true }));
                  this.stickyDddToCart.querySelector('.button__text').style.opacity = '1';
                  this.stickyDddToCart.querySelector('.button__loader').style.opacity = '0';

                  this.classList.remove('open');
                  this.classList.remove('active');

                  setTimeout(() => {
                    this.classList.add('active');
                  }, 3000);
                 
                })
                .catch((error) => {
                  console.error('Error:', error);
                });
            })
        }






        openPopup(){

            const runStickyPopup = (isMobile = true) => {
                if(this.realVariants === false && this.customVariants === false){
                  //add without variannts
                  this.addTocartProduct();
                   if(isMobile){
                        this.stickyDddToCart.click();
                     }
                }else{

                  if(isMobile){
                    this.classList.add('open');
                  }

                  if(this.customVariants === false){
                    //add with default variannts
                      this.createStickyProduct();
                      
                  }else{
                      //add with static variant
                      console.log('static variants')
                       this.customSelectVariantsDefault();
                      this.variantsChange(null);
                      this.addTocartProduct();
                   
                  }
              }

              
            }

           if(window.innerWidth >= 750){
            runStickyPopup(false);
           }
            
        
            this.stickyBuyOpen.addEventListener('click', (e) => {
                e.preventDefault();

                runStickyPopup(true);
            })
        }

        closePopup(){
            this.stickyBuyClose.forEach(item => {
              item.addEventListener('click', (e) => {
                  if(e.currentTarget == item) this.classList.remove('open')
                  
              })
            })  
        }

  }


  document.addEventListener("DOMContentLoaded", function() {
    if (!customElements.get('sticky-buy')) {
      customElements.define('sticky-buy', StickyBuy);
    }
  }) 

